import styled from 'styled-components'

interface GradientbuttonProps {
	disabled?: boolean;
	big?: boolean;
}

export const Gradientbutton = styled.div<GradientbuttonProps>`
  color: white;
  font-weight: bold;
  font-size: 16px;
  text-align: center;
  padding: 10px ${props => props.big ? '35px' : '20px'};
  border-radius: 20px;
  opacity: 1;
  
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  background: ${props => props.disabled
	? 'gray'
	: 'linear-gradient(145.6deg, #163f51 -8.22%, #1db6f8 149.35%)'};
`
